import ConversationRecord from "models/view-models/conversations/conversation-record";
import { Reducer } from "utilities/atoms/atom-with-thunks-reducer";

type ConversationHistoryReducer = Reducer<
    ConversationHistoryState,
    ConversationHistoryAction
>;

export type ConversationWithoutMessages = Omit<ConversationRecord, "messages">;

export interface ConversationHistoryState {
    conversations: Array<ConversationWithoutMessages>;
    error?: Error;
}

export type ConversationHistoryAction =
    | { type: "ADD_CONVERSATION"; conversation: ConversationWithoutMessages }
    | { type: "CLEAR_CONVERSATION_HISTORY" }
    | { type: "DELETE_CONVERSATION"; id: string }
    | {
          type: "REFRESH_CONVERSATION_HISTORY";
          conversations: Array<ConversationWithoutMessages>;
      }
    | {
          type: "RENAME_CONVERSATION";
          id: string;
          title: string;
      }
    | {
          type: "PIN_OR_UNPIN_CONVERSATION";
          id: string;
          isPinned: boolean;
      }
    | { type: "ERROR"; error: Error }
    | { type: "RESET_ERROR" };

export const conversationHistoryReducer: ConversationHistoryReducer = (
    state,
    action
): ConversationHistoryState => {
    switch (action.type) {
        case "ADD_CONVERSATION":
            return {
                ...state,
                conversations: state.conversations.some(
                    (conversation) => conversation.id === action.conversation.id
                )
                    ? state.conversations.map((conversation) =>
                          conversation.id === action.conversation.id
                              ? action.conversation
                              : conversation
                      )
                    : [...state.conversations, action.conversation],
            };

        case "CLEAR_CONVERSATION_HISTORY":
            return {
                conversations: [],
            };

        case "DELETE_CONVERSATION":
            return {
                ...state,
                conversations: state.conversations.filter(
                    (c) => c.id !== action.id
                ),
            };

        case "REFRESH_CONVERSATION_HISTORY":
            return {
                ...state,
                conversations: action.conversations,
            };

        case "RENAME_CONVERSATION":
            return {
                ...state,
                conversations: state.conversations.map((conversation) =>
                    conversation.id === action.id
                        ? conversation.with({ title: action.title })
                        : conversation
                ),
            };
        case "PIN_OR_UNPIN_CONVERSATION":
            return {
                ...state,
                conversations: state.conversations.map((conversation) =>
                    conversation.id === action.id
                        ? conversation.with({ isPinned: action.isPinned })
                        : conversation
                ),
            };

        case "ERROR":
            return {
                ...state,
                error: action.error,
            };

        case "RESET_ERROR":
            return {
                ...state,
                error: undefined,
            };
    }
};

conversationHistoryReducer.defaultState = {
    conversations: [],
};
